export function isEmpty(obj) {
  for (let item in obj) {
    if (Object.hasOwn(obj, item)) return false;
  }
  return true;
}
export function arrayRemove(arr, value) {
  return arr.filter(function (ele) {
    return ele != value;
  });
}

/**
 *
 * @param {array} arr1
 * @param {array} arr2
 * @returns {array} arr1 without arr2
 */
export function arrayDiff(arr1, arr2) {
  return arr1.filter((x) => !arr2.includes(x));
}

/**
 *
 * @param {array} arr1
 * @param {array} arr2
 * @returns common items
 */
export function arrayIntersection(arr1, arr2) {
  const set2 = new Set(arr2);
  return arr1.filter((item) => set2.has(item));
}

export function capitalizeFirstLetter(string) {
  if (typeof str !== "string" || !str.length) return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
}
//check for nested object
export function checkNested(obj, level, ...rest) {
  if (obj === undefined) return false;
  if (rest.length == 0 && obj.hasOwnProperty(level)) return true;
  return checkNested(obj[level], ...rest);
}

//get nested object
export function getNested(obj, ...args) {
  // return args.reduce((obj, level) => obj && obj[level], obj);
  return args.reduce((acc, level) => acc?.[level], obj);
}

/*const test = { level1:{ level2:{ level3:'level3'} } };
console.log(getNested(test, 'level1', 'level2', 'level3')); // 'level3'
console.log(getNested(test, 'level1', 'level2', 'level3', 'length')); // 6
console.log(getNested(test, 'level1', 'level2', 'foo')); // undefined
console.log(getNested(test, 'a', 'b')); // undefined*/

export function formatPortLabel(str) {
  if (str.includes("AUX")) {
    const lastChar = str.slice(-1);
    return `Aux.Port ${lastChar}`;
  }

  const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);
  const [slot = "", port = ""] = str.split(".", 2);
  return port ? `${capitalize(slot)}.${capitalize(port)}` : capitalize(slot);
}

export function formatSlotLabel(str) {
  if (str === "slot0") {
    return "Flex Slot";
  }
  if (str === "macd") {
    return "Sw.CPU";
  }

  if (str.includes("slot")) {
    let matches = str.match(/(\d+)/);
    return matches ? `Slot ${matches[0]}` : `Slot`;
    //  str.charAt(0).toUpperCase() +  str.slice(1);
  } else {
    return str.toUpperCase();
  }
}
export function getSocketNumber(socket) {
  if (socket.includes("AUX")) {
    // const replaced = socket.replace(/AUX/g, "");
    return socket;
  }
  const replaced = socket.replace(/\D/g, "");
  return replaced;
}

export function mergeLeft(arr1, arr2) {
  let arrDiff1 = arr1.filter(function (e) {
    return !arr2.includes(e);
  });

  return arrDiff1;
}

/**
 * slotNumber from slotName. 'Slot x' only
 * @param {string} currentSlot
 * @returns {number}
 */
export function slotNumber(currentSlot) {
  let slotNumber = null;
  if (currentSlot.includes("slot")) {
    slotNumber = Number(currentSlot.slice(4));
  }
  return slotNumber;
}

/**
 *
 * @param {string} currentSlotName
 * @param {string} frameSize
 * @returns {string} prior slot Number from slotName
 */
export function priorSlotNumber(currentSlotName, fs) {
  // let slotNumber = 0;
  if (currentSlotName.includes("slot")) {
    let slotNumber = Number(currentSlotName.slice(4));
    if (currentSlotName == "slot0") {
      return null;
    }
    if (currentSlotName == "slot1") {
      if (fs == "12" || fs == "2" || fs == "1") {
        return null;
      }
    }
    return slotNumber - 1;
  }
  return null;
}
